<template>
  <cTable
    :fields="fields"
    :methods="methods"
    :modals="modals"
    :config="config"
    :header="header"
    ref="table"
  >
    <template #header>
      <Tabs v-model="tabName" @on-click="handleTab">
        <TabPane
          :label="item.label"
          :name="item.value"
          v-for="item in tabList"
          :key="item.value"
        />
      </Tabs>
    </template>
    <!-- <template #FLOW="{params,visible}">
				<Flow v-if="visible && params.process" :list="params.process"></Flow>
			</template> -->
  </cTable>
</template>

<script>
import {
  getList,
  detail,
  upload,
  save,
  cancel,
  deleteItem,
  cash,
  info,
  amount,
  update,
} from "@/api/reimburse/apply.js";
import Flow from "./flow.vue";
import { getList as Category } from "@/api/reimburse/category.js";
import { getList as Suject } from "@/api/reimburse/suject.js";
import cTable from "@/base/common/index";
import { getCurrency } from "@/api/finance/currency";
import { getWarehouse } from "@/api/storage/warehouse";
export default {
  name: "reimburseApply",
  components: {
    Flow,
    cTable,
  },
  async mounted() {
    Suject().then((res) => {
      if (!res.data.status) return;
      this.sujectList = res.data.payload.map((t) => {
        return {
          label: this.$i18n.locale === "zh-CN" ? t.name : t.name_eng,
          value: t.id,
          children: t.children.map((t) => {
            return {
              label: this.$i18n.locale === "zh-CN" ? t.name : t.name_eng,
              value: t.id,
              children: t.children || [],
            };
          }),
        };
      });
      console.log(this.sujectList);
    });
  },
  methods: {
    handleTab() {
      this.$refs["table"].getList();
    },
    tabChange(name) {
      // this.modals.add.config.hideForm = name == 1?false:true
      this.modals.add.table.fields = this.tableFields[name - 1];
      this.modals.add.table.config.height = name == 1 ? 250 : 539;
      let modal = this.$refs["table"].getModal("add");
      modal.list = modal.params[name == 1 ? "details" : "process"];
    },
  },
  data() {
    let that = this;
    return {
      mode: "1",
      tabName: "1",
      sujectList: [],
      tabList: [
        {
          label: this.$t("inReview"),
          value: "0",
        },
        {
          label: this.$t("Passed"),
          value: "1",
        },
        {
          label: this.$t("Rejected"),
          value: "2",
        },
        {
          label: this.$t("alreadyRepeal"),
          value: "3",
        },
      ],
      typeList: [
        {
          label: this.$t("personal"),
          value: 1,
        },
        {
          label: this.$t("assistDepartment"),
          value: 2,
        },
      ],
      currencyTypeList: [
        {
          label: this.$t("cash"),
          value: 1,
        },
        {
          label: this.$t("bank deposit"),
          value: 2,
        },
      ],
      methods: {
        list: (data) => {
          data.status = this.tabName;
          return getList(data);
        },
        Category,
        detail,
        save,
        getCurrency,
        cancel,
        deleteItem,
        Suject,
        cash,
        info,
        amount,
        getWarehouse,
        update,
      },
      config: {
        height: 630,
        showOverflow: false,
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("reimburseApply"),
              type: "launch",
              fnName: "launch",
              bind: {
                type: "primary",
              },
              id: 1060,
            },
            {
              name: () => this.$t("applyImprest"),
              type: "imprest",
              fnName: "imprest",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            launch: () => {
              // this.modals.add.config.hideForm = false
              this.modals.add.config.width = 800;
              this.$refs["table"].getModal("add").open({}, function () {
                this.setFormData({ files: [] });
                this.list = [{}];
              });
            },
            imprest() {
              this.handleRequestMethods("info").then((res) => {
                this.getModal("imprest").open(res.payload);
              });
            },
          },
        },
      },
      tableFields: [
        [
          {
            type: "seq",
            width: 50,
          },
          {
            name: () => this.$t("approver"),
            key: "user_name",
          },
          {
            name: () => this.$t("CurrentState"),
            key: "status",
            methods: {
              render({ value }) {
                let name = [
                  "ApprovalPending",
                  "Passed",
                  "Rejected",
                  "alreadyRepeal",
                ];
                return this.$t(name[value]);
              },
            },
          },
          {
            name: () => this.$t("approval_time"),
            key: "check_time",
          },
          {
            name: () => this.$t("approval_remark"),
            key: "notes",
          },
        ],
      ],
      modals: {
        imprest: {
          type: "add",
          methods: {
            ok({ row, close }) {
              if (row.id) row.source = 2;
              this.$page
                .handleRequestMethods(
                  row.id ? "update" : "cash",
                  row,
                  true,
                  true
                )
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$t("applyImprest"),
            modalBind: {
              width: 600,
              draggable: true,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {
              labelWidth: 100,
              disabled() {
                return this.formData.preview;
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              reason: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              amount: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  min: 0.1,
                  max: 1000000,
                  trigger: "blur",
                },
              ],
              currency_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "change",
                },
              ],
              warehouse_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { user_name: 24 },
            { department: 24 },
            { currency_type: 24 },
            { warehouse_id: 24 },
            { create_time: 24 },
            { reason: 24 },
            { amount: 24 },
            { currency_id: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: () => this.$tz("报销时间"),
              key: "create_time",
              placeholder: () => this.$tz("报销时间"),
              component: "DatePicker",
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss",
              },
            },
            {
              key: "currency_type",
              name: this.$tz("报销方式"),
              component: "Select",
              placeholder: this.$tz("报销方式"),
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.currencyTypeList;
                },
              },
            },
            {
              name: this.$tz("仓库"),
              key: "warehouse_id",
              component: "Select",
              placeholder: () => this.$tz("仓库"),
              options: [],
              optionsFn: "getWarehouse",
              optionsKey: "",
              default: "",
            },
            {
              key: "type_id",
              name: this.$t("type"),
              component: "Select",
              placeholder: this.$t("type"),
              options: [
                {
                  label: "个人",
                  value: "1",
                },
                {
                  label: "部门",
                  value: "2",
                },
              ],
            },
            {
              key: "title",
              name: this.$t("applyTitle"),
              placeholder: this.$t("applyTitle"),
              component: "Input",
            },
            {
              key: "user_name",
              name: this.$t("proposer"),
              placeholder: " ",
              component: "Input",
              disabled: true,
            },
            {
              key: "department",
              name: this.$t("applyDepartment"),
              placeholder: " ",
              component: "Input",
              disabled: true,
            },
            {
              key: "amount",
              name: this.$t("applyAmount"),
              placeholder: this.$t("applyAmount"),
              component: "InputNumber",
              default: 0,
              bind: {
                min: 0.1,
                max: 1000000,
                style: "width:100%",
              },
            },
            {
              key: "reason",
              name: this.$t("applyReason"),
              placeholder: this.$t("applyReason"),
              component: "Input",
            },
            {
              key: "remarks",
              component: "Input",
              name: this.$t("Remarks"),
              placeholder: this.$t("Remarks"),
              bind: {
                type: "textarea",
              },
            },
            {
              name: () => this.$t("currency_t"),
              key: "currency_id",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("currency_t"),

              options: [],
              config: {
                label: "code",
                value: "id",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCurrency")
                  ).payload.rows;
                },
              },
            },
          ],
        },
        add: {
          contentTop: "FLOW",
          type: "add",
          contentSlot: "TABS",
          methods: {
            ok({ row, close }) {
              this.list.forEach((t) => {
                if (t.name) {
                  t.name_pid = t.name[0];
                  t.name_id = t.name[1];
                }
              });
              if (!row.files.length)
                return this.$Message.error({
                  content: this.$t("upload") + this.$t("files"),
                  background: true,
                });
              let data = JSON.parse(JSON.stringify(row));
              data.details = this.list;
              this.$page
                .handleRequestMethods(
                  data.id ? "update" : "save",
                  data,
                  true,
                  true
                )
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            width: 1200,
            showForm: () => {
              return this.mode == 1;
            },
            modalContentBind: {
              style: {
                display: "flex",
              },
            },
            modalBind: {
              draggable: true,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {
              labelWidth: 100,
              disabled() {
                return this.formData.preview;
              },
            },
            title: this.$t("reimburseDetail"),
            rules: {
              type_id: [
                {
                  required: true,
                  message: "cannot be empty",
                },
              ],
              warehouse_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
              currency_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
              title: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              reason: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          footer: {
            show() {
              return !this.params.preview;
            },
          },
          grid: [
            { warehouse_id: 24 },
            { currency_type: 24 },
            { currency_id: 12, amount: 12 },
            { create_time: 24 },
            {
              reason: 24,
            },
            {
              remarks: 24,
            },
            { files: 24 },
          ],

          fields: [
            {
              name: () => this.$tz("报销时间"),
              key: "create_time",
              placeholder: () => this.$tz("报销时间"),
              component: "DatePicker",
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss",
              },
            },
            {
              key: "warehouse_id",
              name: () => this.$t("warehouseName"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("warehouseName");
              },
              options: [],
              config: {
                label: "title",
                value: "id",
              },

              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getWarehouse")
                  ).payload.rows;
                  this.$forceUpdate();
                },
                "on-change"({ field, value, formData }) {
                  if (formData.currency_id && formData.warehouse_id)
                    this.$page
                      .handleRequestMethods("amount", {
                        currency_id: formData.currency_id,
                        warehouse_id: formData.warehouse_id,
                      })
                      .then((res) => {
                        formData.amount = res.payload;
                        this.$forceUpdate();
                      });
                },
              },
            },
            {
              key: "currency_type",
              name: this.$tz("报销方式"),
              component: "Select",
              placeholder: this.$tz("报销方式"),
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.currencyTypeList;
                },
              },
            },
            {
              key: "type_id",
              name: this.$t("reimburse") + this.$t("type"),
              component: "Select",
              placeholder: this.$t("type"),
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.typeList;
                },
              },
            },
            {
              key: "title",
              name: this.$t("zhTitle"),
              placeholder: this.$t("zhTitle"),
              component: "Input",
            },
            {
              key: "reason",
              name: this.$t("reimburse") + this.$t("reason"),
              placeholder: this.$t("reason"),
              component: "Input",
            },
            {
              key: "amount",
              name: this.$t("ImprestBalance"),
              placeholder: this.$t("ImprestBalance"),
              component: "Input",
              disabled: true,
              default: 0,
            },
            {
              key: "remarks",
              component: "Input",
              name: this.$t("Remarks"),
              placeholder: this.$t("Remarks"),
              bind: {
                type: "textarea",
              },
            },
            {
              name: () => this.$t("currency_t"),
              key: "currency_id",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("currency_t"),
              options: [],
              config: {
                label: "code",
                value: "id",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCurrency")
                  ).payload.rows.map((t) => {
                    t.amount = "";
                    return t;
                  });
                },
                "on-change"({ field, value, formData }) {
                  if (formData.currency_id && formData.warehouse_id)
                    this.$page
                      .handleRequestMethods("amount", {
                        currency_id: formData.currency_id,
                        warehouse_id: formData.warehouse_id,
                      })
                      .then((res) => {
                        formData.amount = res.payload;
                        this.$forceUpdate();
                      });
                },
              },
            },
            {
              name: this.$t("updateFile") + this.$t("files"),
              key: "files",
              default: [],
              component: "Upload",
              deleteFile({ formData }) {
                return !formData.preview;
              },
              bind: {
                previewFile: true,
                KH: true,
                multiple: true,
                fileName: "files",
                preview({ formData }) {
                  return !formData.preview;
                },
              },
              methods: {
                fileClick({ row }) {
                  window.open(this.$globalUrl + row.src);
                },
                KHConfirm({ file, formData }) {
                  console.log("chufa", file);
                  let data = new FormData();
                  data.append("file", file);
                  upload(data).then((res) => {
                    if (res.data.status) {
                      this.$page.toast(this.$t("gatherSuccess"));
                      formData["files"].push({
                        filename: file.name,
                        src: res.data.payload.url,
                      });
                      // this.$refs["table"].getModal("add").setFormData({files:formData['files']})
                    } else {
                      this.$Message[res.data.status ? "success" : "error"]({
                        background: true,
                        content: res.data.msg,
                      });
                    }
                  });
                },
                beforeUpload: ({ file, formData }) => {
                  let data = new FormData();
                  data.append("file", file);
                  upload(data).then((res) => {
                    this.$Message[res.data.status ? "success" : "error"]({
                      background: true,
                      content: res.data.msg,
                    });
                    if (res.data.status) {
                      formData["files"].push({
                        filename: file.name,
                        src: res.data.payload.url,
                      });
                      // this.$refs["table"].getModal("add").setFormData({files:formData['files']})
                    }
                  });
                  return false;
                },
              },
            },
          ],
          table: {
            config: {
              height: 250,
            },
            fields: [
              {
                name: () => this.$t("detailName"),
                key: "name",
                component: "Cascader",
                disabled: () => this.$modal.params.preview,
                options: [],
                bind: {
                  transfer: true,
                },
                placeholder() {
                  return this.$t("select") + this.$t("detailName");
                },
                disabled({ row }) {
                  return !!(this.$modal.params && this.$modal.params.id);
                },
                methods: {
                  list: ({ field }) => {
                    field.options = this.sujectList;
                  },
                },
              },
              {
                name: () => this.$t("detailAmount"),
                key: "money",
                component() {
                  return this.$modal.params.preview ? "span" : "Input";
                },
                placeholder() {
                  return this.$t("enter") + this.$t("detailAmount");
                },
              },
              {
                name: () => this.$t("Remarks"),
                key: "describe",
                component() {
                  return this.$modal.params.preview ? "span" : "Input";
                },
                placeholder() {
                  return this.$t("enter") + this.$t("Remarks");
                },
              },
              {
                type: "btns",
                width: 80,
                name: () => this.$t("operation"),
                show() {
                  return !this.$modal.params.id;
                },
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "warning",
                    },
                    show() {
                      return !this.$modal.params.id;
                    },
                  },
                  {
                    name: () => this.$t("delete"),
                    disabled() {
                      return this.list.length == 1;
                    },
                    show() {
                      return !this.$modal.params.id;
                    },
                    type: "delete",
                    fnName: "delete",
                    bind: {
                      type: "error",
                    },
                  },
                ],
                methods: {
                  add({ rowIndex }) {
                    this.getModal("add").list.splice(rowIndex + 1, 0, {});
                  },
                  delete({ rowIndex }) {
                    this.getModal("add").list.splice(rowIndex, 1);
                  },
                },
              },
            ],
          },
        },
      },

      fields: [
        {
          key: "warehouse",
          name: this.$t("warehouse"),
          align: "center",
          minWidth: 100,
        },
        {
          key: "apply_type_name",
          name: this.$t("reimburse") + this.$t("type"),
          align: "center",
          width: 100,
        },
        {
          key: "reason",
          name: this.$t("reimburse") + this.$t("reason"),
          align: "center",
          minWidth: 100,
        },
        {
          key: "amount",
          name: this.$t("reimburse") + this.$t("total_amount"),
          align: "center",
          minWidth: 100,
        },
        {
          key: "currency_type_name",
          name: this.$tz("报销方式"),
          align: "center",
          minWidth: 100,
        },
        {
          key: "currency",
          name: this.$t("currency_t"),
          align: "center",
          minWidth: 100,
        },
        {
          key: "remarks",
          name: this.$t("Remarks"),
          align: "center",
          minWidth: 100,
        },
        // {
        // 		"key": "checker",
        // 		"name": this.$t("current_approver"),
        // 		"align": "center"
        // },
        // {
        // 		"key": "status",
        // 		"name": this.$t("reimburse")+this.$t("exlType"),
        // 		"align": "center",
        // 		methods:{
        // 			render({value}){
        // 				let name = ['inReview','Passed','Rejected','alreadyRepeal']
        // 				return this.$t(name[value])
        // 			}
        // 		}
        // },
        {
          key: "create_time",
          name: "创建时间",
          align: "center",
          minWidth: 100,
        },
        {
          type: "btns",
          width: 80,
          name: () => this.$t("operation"),
          list: [
            {
              name: () => this.$t("edit"),
              type: "detail",
              fnName: "detail",
              bind: {
                type: "primary",
              },
            },
            //       {
            //         name: () =>
            //           this.$t("detail"),
            //         type: "detail",
            //         fnName: "detail",
            //         bind: {
            //           type: "primary",
            //         },
            // 	id:1059
            //       },
            // {
            //   name: () =>
            //     this.$t("repeal"),
            //   type: "repeal",
            //   fnName: "repeal",
            //   bind: {
            //     type: "warning",
            //   },
            // 	disabled({row}){
            // 		return row.status == 3
            // 	},
            // 	id:1059
            // },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
              id: 1059,
            },
          ],
          methods: {
            // edit({row}){
            // 	this.handleRequestMethods("update", row.id).then(res => {
            // 	  this.getModal('add').open(res.payload,function(){
            // 	  	this.list = res.payload.details.map(t=>{
            // 	  		t.name = [t.name_pid]
            // 	  		if(t.name_id)t.name[1] = t.name_id
            // 	  		return t
            // 	  	})
            // 	  })
            // 	});
            // },
            repeal({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("repeal"),
                width: 300,
                content: row.title,
                onOk: () => {
                  this.handleRequestMethods("cancel", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: row.title,
                onOk: () => {
                  this.handleRequestMethods("deleteItem", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            detail: ({ field, row }) => {
              let table = this.$refs["table"];
              // this.modals.add.config.hideForm = false
              table.handleRequestMethods("detail", row.id).then((res) => {
                // res.payload.preview = true
                // this.mode = '1'
                // this.modals.add.config.width = 1200
                this.modals.add.config.width = 800;
                table
                  .getModal(row.apply_type == 1 ? "add" : "imprest")
                  .open(res.payload, function () {
                    this.list = res.payload.details.map((t) => {
                      t.name = [t.name_pid];
                      if (t.name_id) t.name[1] = t.name_id;
                      return t;
                    });
                    console.log(this.list);
                  });
              });
            },
          },
        },
      ],
    };
  },
};
</script>
